// src/HolaMundo.js
import React, { useEffect, useMemo, useState } from 'react';
import { apiGet, apiPost, API_BASE } from '../api';


const HolaMundo = () =>  {
  const [email, setEmail] = useState('admin@demo.com');
  const [password, setPassword] = useState('123456');
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user') || 'null'); }
    catch { return null; }
  });

  const [loginLoading, setLoginLoading] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [perfilesLoading, setPerfilesLoading] = useState(false);
  const [perfilesData, setPerfilesData] = useState(null);

  const isLogged = !!token;

  useEffect(() => {
    if (token) localStorage.setItem('token', token);
    else localStorage.removeItem('token');
  }, [token]);

  useEffect(() => {
    if (user) localStorage.setItem('user', JSON.stringify(user));
    else localStorage.removeItem('user');
  }, [user]);

  const apiInfo = useMemo(() => ({
    base: API_BASE,
    loginPath: '/login.php',
    perfilesPath: '/perfiles/src/get.php',
  }), []);

  async function handleLogin(e) {
    e.preventDefault();
    setLoginError('');
    setLoginLoading(true);
    setPerfilesData(null);

    const { ok, data, status } = await apiPost(apiInfo.loginPath, { email, password });
    setLoginLoading(false);

    if (!ok) {
      setLoginError(data?.message || `Error ${status}`);
      return;
    }
    // data.data.token y data.data.user según tu mock
    const tk = data?.data?.token;
    const usr = data?.data?.user || null;

    if (!tk) {
      setLoginError('No se recibió token');
      return;
    }
    setToken(tk);
    setUser(usr);
  }

  function handleLogout() {
    setToken('');
    setUser(null);
    setPerfilesData(null);
    setLoginError('');
  }

  async function cargarPerfiles() {
    if (!token) return;
    setPerfilesLoading(true);
    setPerfilesData(null);
    const { ok, data, status } = await apiGet(apiInfo.perfilesPath, token);
    setPerfilesLoading(false);
    if (!ok) {
      setPerfilesData({ error: data?.message || `Error ${status}`, raw: data });
    } else {
      setPerfilesData(data);
    }
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={{ marginBottom: 8 }}>Demo Auth + Perfiles</h2>
        <p style={{ marginTop: 0, color: '#666' }}>
          API base: <code>{apiInfo.base}</code>
        </p>

        {!isLogged ? (
          <form onSubmit={handleLogin} style={styles.form}>
            <label style={styles.label}>Email</label>
            <input
              style={styles.input}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              placeholder="admin@demo.com"
            />

            <label style={styles.label}>Password</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              placeholder="123456"
            />

            <button style={styles.btnPrimary} type="submit" disabled={loginLoading}>
              {loginLoading ? 'Ingresando...' : 'Ingresar'}
            </button>

            {loginError && <div style={styles.error}>{loginError}</div>}
          </form>
        ) : (
          <>
            <div style={styles.infoBox}>
              <div><strong>Usuario:</strong> {user?.email || '(sin email)'}</div>
              <div><strong>Rol:</strong> {user?.role || '(sin rol)'}</div>
              <div style={{ wordBreak: 'break-all' }}>
                <strong>Token:</strong> {token.slice(0, 32)}... (guardado en localStorage)
              </div>
            </div>

            <div style={{ display: 'flex', gap: 8 }}>
              <button style={styles.btnPrimary} onClick={cargarPerfiles} disabled={perfilesLoading}>
                {perfilesLoading ? 'Cargando...' : 'Cargar Perfiles (GET)'}
              </button>
              <button style={styles.btnGhost} onClick={handleLogout}>Salir</button>
            </div>
          </>
        )}
      </div>

      <div style={styles.card}>
        <h3 style={{ marginTop: 0 }}>Respuesta de perfiles</h3>
        <pre style={styles.pre}>
{perfilesData ? JSON.stringify(perfilesData, null, 2) : 'Sin datos'}
        </pre>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: '#f6f7fb',
    padding: 24,
    display: 'flex',
    gap: 16,
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  card: {
    background: '#fff',
    border: '1px solid #eee',
    borderRadius: 10,
    padding: 16,
    width: 560,
    boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
  },
  form: { display: 'grid', gap: 8, marginTop: 8 },
  label: { fontSize: 13, color: '#555' },
  input: {
    padding: '10px 12px',
    borderRadius: 8,
    border: '1px solid #ddd',
    outline: 'none'
  },
  btnPrimary: {
    padding: '10px 14px',
    borderRadius: 8,
    border: 'none',
    background: '#0d6efd',
    color: '#fff',
    cursor: 'pointer'
  },
  btnGhost: {
    padding: '10px 14px',
    borderRadius: 8,
    border: '1px solid #ccc',
    background: '#fff',
    color: '#333',
    cursor: 'pointer'
  },
  error: {
    marginTop: 8,
    background: '#feefef',
    border: '1px solid #f5c2c7',
    color: '#b02a37',
    padding: 8,
    borderRadius: 8
  },
  infoBox: {
    background: '#f2f7ff',
    border: '1px solid #d8e7ff',
    color: '#204a8e',
    padding: 12,
    borderRadius: 8,
    marginBottom: 12
  },
  pre: {
    background: '#0f172a',
    color: '#e2e8f0',
    fontSize: 13,
    padding: 12,
    borderRadius: 8,
    maxHeight: 360,
    overflow: 'auto'
  }
};


export default HolaMundo;